export default __webpack_public_path__ + "static/media/image.pelican-cube-pvt-ltd.516d8c07.png";